// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1vDFR","label":"Section_label__Q_7No","contentWrap":"Section_contentWrap__3Zv_a","footer":"Section_footer__APYRl","footerInner":"Section_footerInner__1MC5t"};